import { notify } from "@kyvg/vue3-notification";

var prod = "https://b2b-backend.farframes.it/";
var dev = "https://api-test.onstep.it/";
var baseLink =
  location.hostname === "localhost" ||
  location.hostname === "127.0.0.1" ||
  location.hostname === ""
    ? (baseLink = dev)
    : (baseLink = prod);

const verifyConnection = (data, callback) => {
  if (!data.success) {
    if (data.exception && data.exception.includes("ConnectException")) {
      notify({
        title: "Connection",
        text: "Ritenta più tardi, time out, TECNO data",
        type: "error",
      });
      return;
    }
    if (
      data &&
      data.response &&
      data.response.data &&
      data.response.data.exception &&
      data.response.data.exception.includes("Authentication") &&
      data.response.data.code == 401
    ) {
      notify({
        title: "Connection",
        text: data.response.data.message,
        type: "error",
      });

      if (typeof callback !== "undefined") {
        callback = false;
        return callback;
      }
      return;
    }
    if (
      data &&
      data.response &&
      data.response.data &&
      data.response.data.exception.includes("Exception")
    ) {
      notify({
        title: "Errore",
        text: data.response.data.message,
        type: "error",
      });
      return;
    }
  }
};

export { baseLink, verifyConnection };
